const backgroundColor = "#ebeffb";

export const fallbackValues = {
  backgroundColor
};
